import React from 'react';
import { FileText, CalendarDays, History, Wallet, RefreshCw } from 'lucide-react';
import { Tabs } from '@shared/ui/tabs';
import { PageHeader } from '@shared/components/PageHeader';
import { BillsAndService } from './tabs/Bills&Service';
import { Installments } from './tabs/Installments';
import { PaymentHistory } from './tabs/PaymentHistory';
import { CreditNotes } from './tabs/CreditNotes';
import { Autopay } from './tabs/Autopay';
import { useTranslation } from 'react-i18next';
import { useCombinedBillsServices, useCreditNoteList } from '../hook';
import { getLoginDataFromStorage, getRemoteUtilityId } from '@shared/utils/loginUtils';

export const BillsLanding = () => {
  const { t } = useTranslation();
  const { data: combinedBillsServicesData } = useCombinedBillsServices({
    remote_utility_id: getRemoteUtilityId(),
    consumer_number: getLoginDataFromStorage().remoteConsumerNumber,
    is_pagination_required: true,
  });

  const { data: creditNotesData } = useCreditNoteList({
    remote_utility_id: getRemoteUtilityId(),
    consumer_id: getLoginDataFromStorage().consumerId,
    payment_pay_type: 3,
  });

  const getTabConfigs = (t: any) => ({
  currentBill: {
    label: t("Bills & Services"),
    icon: <FileText className="w-4 h-4 mr-2" />,
    count: combinedBillsServicesData?.count,
    component: <BillsAndService />
  },
  installments: {
    label: t("Installments"),
    icon: <CalendarDays className="w-4 h-4 mr-2" />,
    component: <Installments />
  },
  paymentHistory: {
    label: t("Payment History"),
    icon: <History className="w-4 h-4 mr-2" />,
    component: <PaymentHistory />
  },
  creditNotes: {
    label: t("Credit Notes"),
    icon: <Wallet className="w-4 h-4 mr-2" />,
    count: creditNotesData?.activeCredits ?? creditNotesData?.count,
    component: <CreditNotes />
  },
  autopay: {
    label: t("Autopay"),
    icon: <RefreshCw className="w-4 h-4 mr-2" />,
    component: <Autopay />
  }
});
    const tabConfigs = React.useMemo(() => getTabConfigs(t), [t, combinedBillsServicesData, creditNotesData]);



  return (
    <div className="p-6 space-y-6">
      <PageHeader title={t("Billing")} subtitle={t("Manage your bills, payments, and autopay settings")} />
      <Tabs 
        tabComponents={tabConfigs} 
        defaultValue="currentBill"
        className='w-full'
        tabsListFullWidth={true}
        tabsListClassName="grid grid-cols-5 w-full"

      />
    </div>
  );
};

export default BillsLanding;
